import type { Product } from "@jti/magento";

export const hasMatchingSku = (products: Product[], skuList: string[]) =>
  products.some((item) => skuList.includes(item.sku));
